import { surveyTakePageStore } from "../stores";

export const useSurveyTakePageStore = () => surveyTakePageStore;
